import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import Engine from "@milestoneslabs/milestones-js-engine";

export const GLOBAL_UNSUBSCRIBE_EVENT = 'unsubscribe';
export const EXPIRE_EVENT = 'expire';
export const ONBOARD_EVENT = 'onboard';
export const DELIVER_EVENT = 'delivered';
export const OPEN_EVENT = 'open';
export const CLICK_EVENT = 'click';
export const BOUNCE_EVENT = 'bounce';
export const UNSAFE = 'unsafe';
export const REVOKED_EVENT = 'revoked';
export const TOUNCHPOINTS = 'touchpoints';

export const EVENTS = {
    GLOBAL_UNSUBSCRIBE_EVENT,
    EXPIRE_EVENT,
    ONBOARD_EVENT,
    DELIVER_EVENT,
    OPEN_EVENT,
    CLICK_EVENT,
    BOUNCE_EVENT,
    UNSAFE,
    REVOKED_EVENT,
    // Grouped Events
    TOUNCHPOINTS,
};

let MAPPING = {};

MAPPING[EVENTS.ONBOARD_EVENT] = 'Onboarded';
MAPPING[EVENTS.DELIVER_EVENT] = 'Sent';
MAPPING[EVENTS.OPEN_EVENT] = 'Viewed';
MAPPING[EVENTS.CLICK_EVENT] = 'Clicked';
MAPPING[EVENTS.BOUNCE_EVENT] = 'Bounced';
MAPPING[EVENTS.UNSAFE] = 'Unsafe';
MAPPING[EVENTS.EXPIRE_EVENT] = 'Expired';
MAPPING[EVENTS.GLOBAL_UNSUBSCRIBE_EVENT] = 'Unsubscribed';
MAPPING[EVENTS.REVOKED_EVENT] = 'Revoked';

export const EVENTS_MAPPING = MAPPING;

export const ONBOARDING_TYPE = 'onboarding';
export const COMMUNICATIONS_TYPE = 'communications';
export const HUB_ACTIVITY_TYPE = 'hub-activity';
export const ISSUES_TYPE = 'issues';

export const TYPES = {
    ONBOARDING_TYPE,
    COMMUNICATIONS_TYPE,
    HUB_ACTIVITY_TYPE,
    ISSUES_TYPE,
};

export const INVITES_SENT_SUB_TYPE = 'invites-sent';
export const INVITES_OPENED_SUB_TYPE = 'invites-opened';
export const ONBOARDED_SUB_TYPE = 'onboarded';

export const MESSAGES_SENT_SUB_TYPE = 'messages-sent';
export const VIEWED_SUB_TYPE = 'viewed';
export const CLICKED_TO_HUB_SUB_TYPE = 'clicked-to-hub';

export const HUB_VISITS_SUB_TYPE = 'hub-visits';
export const HUB_ACTIVITIES_SUB_TYPE = 'hub-activities';
export const LEAD_SUBMISSIONS_SUB_TYPE = 'lead-submissions';

export const UNCLAIMED_INVITES_SUB_TYPE = 'unclaimed-invited';
export const BAD_EMAIL_ADDRESSES_SUB_TYPE = 'bad-email-addresses';
export const UNSUBSCRIBES_SUB_TYPE = 'unsubscribes';

export const SUB_TYPES = {
    INVITES_SENT_SUB_TYPE,
    INVITES_OPENED_SUB_TYPE,
    ONBOARDED_SUB_TYPE,
    MESSAGES_SENT_SUB_TYPE,
    VIEWED_SUB_TYPE,
    CLICKED_TO_HUB_SUB_TYPE,
    HUB_VISITS_SUB_TYPE,
    HUB_ACTIVITIES_SUB_TYPE,
    LEAD_SUBMISSIONS_SUB_TYPE,
    UNCLAIMED_INVITES_SUB_TYPE,
    BAD_EMAIL_ADDRESSES_SUB_TYPE,
    UNSUBSCRIBES_SUB_TYPE,
};

class SendGridMetricsAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'send-grid-metrics';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'sends/grids/metrics';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'uuid',
            'messageId',
            'templateId',
            'sendGridEventId',
            'userIp',
            'reason',
            'response',
            'eventType',
            'user',
            'agent',
            'campaign',
            'hub',
            'landingPage',
            'organization',
            'createdAt',
            'updatedAt',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [
        ];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [
        ];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            messageId: {
                type: 'string',
                presence: true,
            },
            templateId: {
                type: 'string',
                presence: true,
            },
            sendGridEventId: {
                type: 'string',
                presence: true,
            },
            userIp: {
                type: 'string',
            },
            reason: {
                type: 'string',
            },
            response: {
                type: 'string',
            },
            eventType: {
                type: 'string',
                presence: true,
            },
            'user.uuid': {
                type: 'string',
            },
            'user.email': {
                type: 'string',
                presence: true,
                email: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            'agent.uuid': {
                type: 'string',
            },
            'campaign.uuid': {
                type: 'string',
            },
            'hub.uuid': {
                type: 'string',
            },
            'landingPage.uuid': {
                type: 'string',
            },
            'organization.uuid': {
                type: 'string',
            },
        };
    }

    apiPaths() {
        return {
            ...super.apiPaths(),
            'search': Engine.apiUrl(this.appResourceApiPrefix() + '/search/elastic'),
            counts: Engine.apiUrl(this.appResourceApiPrefix() + '/counts'),
        };
    }

    async getCounts(data) {
        const url = this.apiPaths().counts;
        return await Engine.post(url, data);
    }
}

export default SendGridMetricsAppResource;
